import { lazy } from "react";
import Loadable from "components/Loadable";
import MainLayout from "views/layout/private/Index";

const Dashboard = Loadable(lazy(() => import("views/pages/private/Dashboard")));
const Support = Loadable(
  lazy(() => import("views/pages/private/Support/Support"))
);
const FAQ = Loadable(lazy(() => import("views/pages/private/Support/FAQ")));
const Settings = Loadable(
  lazy(() => import("views/pages/private/Settings/Settings"))
);
const Gallery = Loadable(
  lazy(() => import("views/pages/private/Gallery/Gallery"))
);
const Merchants = Loadable(
  lazy(() => import("views/pages/private/Admin/Merchants"))
);
const Orders = Loadable(lazy(() => import("views/pages/private/Admin/Orders")));
const Profile = Loadable(lazy(() => import("views/pages/private/Profile")));
const ProfileChangePassword = Loadable(
  lazy(() => import("views/pages/private/Profile/UserChangePassword"))
);
const EditProfile = Loadable(
  lazy(() => import("views/pages/private/Profile/UserEditProfile"))
);
const DashboardStoreDetails = Loadable(
  lazy(() => import("views/pages/private/Dashboard/formstore/StoreDetails"))
);
const DashboardProductDetails = Loadable(
  lazy(() => import("views/pages/private/Dashboard/formproduct/ProductDetails"))
);
const DashboardMyProducts = Loadable(
  lazy(() => import("views/pages/private/Dashboard/manageproduct/index"))
);
const DashboardProductDisplay = Loadable(
  lazy(() => import("views/pages/private/Dashboard/displayproduct/index"))
);
const DashboardMyStores = Loadable(
  lazy(() => import("views/pages/private/Dashboard/store/index"))
);

const AdminOrderReviews = Loadable(
  lazy(() => import("views/pages/private/Admin/orderReviews"))
);

const AdminOrderReport = Loadable(
  lazy(() => import("views/pages/private/Admin/OrderReport"))
);

const AdminStores = Loadable(
  lazy(() => import("views/pages/private/Admin/Stores"))
);

const PrivateRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "dashboard",
      element: <Dashboard />,
    },
    {
      path: "dashboard/my-stores",
      element: <DashboardMyStores />,
    },
    {
      path: "dashboard/my-stores/:storeId",
      element: <DashboardStoreDetails />,
    },
    {
      path: "dashboard/my-products/:productId",
      element: <DashboardProductDetails />,
    },
    {
      path: "dashboard/my-products",
      element: <DashboardMyProducts />,
    },
    {
      path: "dashboard/my-stores/:storeId/products",
      element: <DashboardProductDisplay />,
    },
    {
      path: "support",
      element: <Support />,
    },
    {
      path: "settings",
      element: <Settings />,
    },
    {
      path: "merchants",
      element: <Merchants />,
    },
    {
      path: "my-profile",
      element: <Profile />,
    },
    {
      path: "my-profile/change-password",
      element: <ProfileChangePassword />,
    },
    {
      path: "my-profile/update-profile",
      element: <EditProfile />,
    },
    {
      path: "orders",
      element: <Orders />,
    },
    {
      path: "gallery",
      element: <Gallery />,
    },
    {
      path: "FAQ",
      element: <FAQ />,
    },
    {
      path: "admin/reviews",
      element: <AdminOrderReviews />,
    },
    {
      path: "/admin-stores",
      element: <AdminStores />,
    },
    {
      path: "/order-report",
      element: <AdminOrderReport />,
    }
  ],
};

export default PrivateRoutes;
